// extracted by mini-css-extract-plugin
var _1 = "ImageUploaderStyles-module__cover-btn___yWfHK";
var _2 = "ImageUploaderStyles-module__cover-btn___yWfHK";
var _3 = "ImageUploaderStyles-module__crop-container___rSNTl";
var _4 = "ImageUploaderStyles-module__crop-container___rSNTl";
var _5 = "ImageUploaderStyles-module__upload-button___NX5iN";
var _6 = "ImageUploaderStyles-module__upload-button___NX5iN";
export { _1 as "cover-btn", _2 as "coverBtn", _3 as "crop-container", _4 as "cropContainer", _5 as "upload-button", _6 as "uploadButton" }
